// Libs
import React, { useState } from "react";
import { useObserver, useRouter } from "@shoothill/core";
import { LoadingButton } from "Globals/Views/LoadingButton";
import { Box, Radio, Checkbox, Typography } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "Globals/Styles/AppTheme";
import { useMediaQuery } from "@material-ui/core";
// App
import { StoresInstance } from "Globals/Stores";
const domainStores = StoresInstance.Domain;

export const SaveForLaterContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    color: ${theme.palette.common.white};
    background-color: ${theme.palette.hightownGreen.main};
    border-radius: 5px;
    min-height: 55px;
    padding: 15px !important;
    margin: 30px 0px;

    > p {
        margin: 12px 0 12px;
    }

    @media (max-width: 768px) {
        padding: 15px 0px;
    }
`;

export const SaveForLaterView: React.FC = () => {
    const isMobile = useMediaQuery("(max-width: 768px)");
    return useObserver(() => (
        <>
            <SaveForLaterContainer style={isMobile ? { flexDirection: "column", display: "flex" } : {}}>
                <Typography variant={isMobile ? "h4" : "h6"} style={isMobile ? { marginBottom: "20px", textAlign: "center" } : {}}>
                    Shared Ownership Application Form
                </Typography>
                <LoadingButton text={"Save for later"} onClick={domainStores.SaveStore.saveAll} loading={domainStores.SaveStore.isSaving} />
            </SaveForLaterContainer>
        </>
    ));
};
